import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShoppingBag } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function BoutiqueDecouvrirAcheter() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="53035" id="demandez-votre-offre-personnalisée" className="relative w-full py-32 bg-primary flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592750/img/argan_texture_overlay.png)] opacity-10 bg-cover bg-center mix-blend-overlay pointer-events-none" />
      
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/90 via-transparent to-primary/90 pointer-events-none" />

      <div ref={ref} className={cn("relative z-10 container mx-auto px-6 text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <h2 className="text-4xl md:text-6xl lg:text-[72px] font-serif font-bold text-secondary mb-8 tracking-tight drop-shadow-lg">
          Demandez Votre Offre Personnalisée
        </h2>
        
        <p className="text-lg md:text-xl text-secondary/90 max-w-2xl mx-auto mb-12 font-sans font-light leading-relaxed tracking-wide">Sublimez votre espace avec l'intensité de nos grands crus. Nous concevons des solutions exclusives adaptées à vos volumes et à vos exigences de qualité. Réponse rapide sur WhatsApp.</p>

        <div className="flex justify-center">
          <Button asChild className="bg-chart-2 hover:bg-chart-2/90 text-primary text-lg md:text-xl px-10 py-8 rounded-[12px] shadow-xl transition-all hover:scale-105 border-none hover:shadow-[0_0_25px_rgba(218,165,32,0.4)]">
            <Link to="/contact">
              <ShoppingBag className="mr-3 h-6 w-6" />
              Obtenir un Devis
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}